import { render, staticRenderFns } from "./ViewSalesPaymentComponent.vue?vue&type=template&id=79948192"
import script from "./ViewSalesPaymentComponent.vue?vue&type=script&lang=js"
export * from "./ViewSalesPaymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports